import { useDefaultTopLayout, useHomePageDefaultLayout } from "components/layout/layout-methods";

/***
 *  Default Layout
 */
export const getDefaultTopLayout = useDefaultTopLayout;

/***
 * About Us
 */
export const getAboutUsPageLayout = useDefaultTopLayout;

/***
 * how vahak helps
 */
export const getHowVahakHelpsPageLayout = useDefaultTopLayout;

/***
 * Contact Us
 */
export const getContactUsPageLayout = useDefaultTopLayout;

/***
 * Whu Choose Us
 */
export const getWhyChooseUsPageLayout = useDefaultTopLayout;

/***
 * Home
 */
export const getHomePageLayout = useHomePageDefaultLayout;
